import reveal from './modules/reveal';
import initForm from './modules/form';

$(() => {
    reveal.init();
    initForm();
});
